module.exports = __webpack_public_path__ + "static/media/mike.c19bf5d5.png";